module.exports = __webpack_public_path__ + "img/map-lavista.155d7b97.svg";